module.exports = __webpack_public_path__ + "img/accessory-pic.3dd8d0f4.png";